import store from '../../../store';
import { getCart } from '../../../modules/cart';
import { getCustomer } from '../../../modules/customer';
import { getCountryCode } from '../../../modules/config';
import { getSelectedStore, getDeliveryAddress, getSelectedDeliveryOption } from '../../../modules/delivery';
import {
    getBillingAddress,
    getSelectedPaymentMethod,
    getStockCheckPayment,
    getPaymentMethods,
    getAdditionalPaymentServiceDetails
} from '../../../modules/billing';
import { initPaymentCatchErrors } from '../../../lib/networkError/networkError';
import makeRandomString from 'crypto-random-string';
import clone from "rfdc";
import { CandCLocation } from "../../../modules/delivery/types";
import { Customer, Address } from '../../../modules/customer/types';
/**
 *  Wrapper function for the initPaymentCatchErrors() to prepare all parameters for the initPayment() function
 * @param initPayload Provider-specific payload needed to initiate a payment (eg. encrypted card details, etc.)
 * @returns The initPayment() response, or undefined if an error was encountered
 */
export function initializePayment(initPayload:string) {
    const paymentReference = makeRandomString({length: 32}).toUpperCase();
    const { methodId, provider, method } = getPaymentServiceDetails();
    const paymentMethods = getPaymentMethods(store.getState().billing);
    const isExpress =  paymentMethods?.express?.find(item => item.id === methodId) ? true : false;
    const stockCheckPayment = getStockCheckPayment(store.getState().billing);
    const paymentID = stockCheckPayment?.paymentID ? stockCheckPayment.paymentID : undefined;
    const cart = getCart(store.getState().cart);
    // To prepare the cart for Express payment methods
    let customer = {} as Customer;
    let billingAddress = {} as Address;
    let deliveryAddress = {} as Address;
    let countryCode = "";
    let selectedStore = null;
    if(isExpress) {
        customer = getCustomer(store.getState().customer);
        billingAddress = (method === 'clearpayexpress' || method === 'afterpayexpress') ? {} as Address : getBillingAddress(store.getState().billing);
        deliveryAddress = (method === 'clearpayexpress' || method === 'afterpayexpress') ? {} as Address: getDeliveryAddress(store.getState().delivery);
        countryCode = getCountryCode(store.getState().config);
        selectedStore = (method === 'clearpayexpress' || method === 'afterpayexpress') ? getSelectedStoreForApexCpex() : null;
    }
    return initPaymentCatchErrors(
        isExpress,
        provider,
        method,
        paymentReference,
        cart,
        customer,
        billingAddress,
        deliveryAddress,
        selectedStore,
        countryCode,
        paymentID,
        initPayload
    );
}
/**
 * Get the selected payment method gateway, method and clientKey dynamically to pass initPayment() function
 * @returns the selected payment method methodId, gateway, method and clientKey
 */
export function getPaymentServiceDetails() {
    const selectedPaymentMethod = getSelectedPaymentMethod(store.getState().billing);
    return getAdditionalPaymentServiceDetails(selectedPaymentMethod);
}
/**
 * Get the selected store details for Afterpay and Clearpay Express payment methods
 * @returns the selected store or null if no selected
 */
function getSelectedStoreForApexCpex() {
    const selectedStore = getSelectedStore(store.getState().delivery);
    const isCandC = () => {
        const getselectedOption = getSelectedDeliveryOption(store.getState().delivery).value;
        return !!selectedStore.ID && getselectedOption === "clickAndCollect";
    };
    const isClickAndCollect = isCandC();

    let storeParam = clone()(selectedStore);
    if (isClickAndCollect && selectedStore.locationType !== CandCLocation.JD) {
        //Blank out the ID on the selectedStore if it isn't a JD store - the ID is nonsense on a non-JD store until we save it to platform - which we can't do here since saving an address requires a user
        storeParam.ID = '';
    }
    return isClickAndCollect ? storeParam : null;
}
